import { NgModule, Optional, SkipSelf } from '@angular/core';
import { MAT_AUTOCOMPLETE_DEFAULT_OPTIONS } from '@angular/material/autocomplete';
import { MAT_FORM_FIELD_DEFAULT_OPTIONS } from '@angular/material/form-field';
import { MAT_SELECT_CONFIG } from '@angular/material/select';
import { TreoMediaWatcherModule } from './services/media-watcher/media-watcher.module';
import { TreoSplashScreenModule } from './services/splash-screen/splash-screen.module';

@NgModule({
  imports: [TreoMediaWatcherModule, TreoSplashScreenModule],
  providers: [
    {
      // Use the 'fill' appearance on form fields by default.
      // The label is styled to sit above the field, so it is always "floating": otherwise MDC
      // hides the placeholder until the field is focused.
      provide: MAT_FORM_FIELD_DEFAULT_OPTIONS,
      useValue: {
        appearance: 'fill',
        floatLabel: 'always',
      },
    },
    // MDC marks the selected option of single selections with a checkmark; legacy options did not
    {
      provide: MAT_SELECT_CONFIG,
      useValue: { hideSingleSelectionIndicator: true },
    },
    {
      provide: MAT_AUTOCOMPLETE_DEFAULT_OPTIONS,
      useValue: { hideSingleSelectionIndicator: true },
    },
  ],
})
export class TreoModule {
  /**
   * Constructor
   *
   * @param parentModule
   */
  constructor(@Optional() @SkipSelf() parentModule?: TreoModule) {
    if (parentModule) {
      throw new Error('TreoModule has already been loaded. Import this module in the AppModule only!');
    }
  }
}
